import props from "./../../../src-utils/propDefiner";

export default {
  ...props("span", Number, "pm-grid-item"),
};
